module.exports = __webpack_public_path__ + "static/media/rotiping_end.497bb996.png";